const BigNumber = require('bignumber.js');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');

/**
 * These statuses correspond to those used in Backoffice except for cancelled. When a Payment on Account payment is
 * fulfilled by a real payment we may want to update it to paid = 0 and pending = 0. This is a temporary solution
 * as our payment statuses are a bit simplistic at the moment.
 *
 * @param {Payment} payment
 * @returns {string}
 */
const getPaymentStatusLangKey = (payment) => {
    if (payment.isSettled()) {
        return 'PAYMENT_STATUS.SETTLED';
    } else if (payment.isFailed()) {
        return 'PAYMENT_STATUS.FAILED';
    } else if (payment.paid === true) {
        return 'PAYMENT_STATUS.PAID';
    }
    return 'PAYMENT_STATUS.PENDING';
};

const getTotalOfPayments = (payments) => {
    return payments
        .map((p) => p.amount)
        .reduce((total, amount) => {
            return new BigNumber(total).plus(new BigNumber(amount))
                .toFixed(2);
        }, '0.00');
};

/**
 * @param {Payment[]} payments
 * @return {string}
 */
const getTotalOfCompletedPayments = (payments) => {
    return getTotalOfPayments(
        payments.filter((payment) => payment.paid)
    );
};

/**
 * @param {Payment[]} payments
 * @return {string}
 */
const getTotalOfPendingPayments = (payments) => {
    return getTotalOfPayments(
        payments.filter((payment) => payment.pending)
    );
};

/**
 * @param {Payment[]} payments
 * @return {string}
 */
const getTotalOfFailedPayments = (payments) => {
    return getTotalOfPayments(
        payments.filter((payment) => payment.isFailed())
    );
};

/**
 * @param {Payment[]} payments
 * @return {string}
 */
const getTotalOfSettledPayments = (payments) => {
    return getTotalOfPayments(
        payments.filter((payment) => payment.isSettled())
    );
};

/**
 * @param {number} orderTotal
 * @param {string} paymentsTotal
 * @return {string}
 */
const getOutstandingBalanceOfOrder = (orderTotal, paymentsTotal) => {
    return new BigNumber(orderTotal)
        .minus(new BigNumber(paymentsTotal))
        .toFixed(2);
};

/**
 * Add up the amount of all payments in the array that are pending GoCardless payments.
 * These are special cases that we treat as paid because we expect them to complete.
 *
 * @param {Payment[]} payments
 * @return {string}
 */
const getTotalOfPendingGoCardlessPayments = (payments) => {
    return getTotalOfPayments(
        payments.filter((payment) => {
            return payment.paymentMethod?.ref === PaymentMethodRef.GOCARDLESS
                && payment.pending
                && !payment.paid;
        })
    );
};

const getTotalOfCompletePaymentsIncludingTrustedPending = (payments) => {
    return (new BigNumber(getTotalOfCompletedPayments(payments)))
        .plus(new BigNumber(getTotalOfPendingGoCardlessPayments(payments)))
        .toFixed(2);
};

module.exports = {
    getOutstandingBalanceOfOrder,
    getPaymentStatusLangKey,
    getTotalOfPayments,
    getTotalOfCompletedPayments,
    getTotalOfCompletePaymentsIncludingTrustedPending,
    getTotalOfFailedPayments,
    getTotalOfPendingGoCardlessPayments,
    getTotalOfPendingPayments,
    getTotalOfSettledPayments,
};
